import {Component, OnInit} from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {FormControl, FormGroup, Validators} from '@angular/forms';


@Component({
  selector: 'app-cambio-modal',
  templateUrl: './cambio-modal.component.html',
  styleUrls: ['./cambio-modal.component.css']
})
export class CambioModalComponent implements OnInit {
  cambio: FormGroup;
  constructor(public dialogRef: MatDialogRef<CambioModalComponent>,
               ) {
    this.crearFormulario();
  }

  ngOnInit(): void {
    this.crearFormulario();
  }


  onTipoTramiteChange(): void {}

  crearFormulario(): any {
    this.cambio = new FormGroup({
      tipo: new FormControl('', Validators.required),
      tipoTramite : new FormControl('', Validators.required),
      numPedido: new FormControl(''),
      //justificante: new FormControl('')
    });
  }
}
